import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2d3436] relative overflow-hidden">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)'
        }}></div>
      </div>

      {/* Cyan accent bar */}
      <div className="h-2 bg-gradient-to-r from-[#00d4ff] via-[#00b8e6] to-[#00d4ff] animate-gradient"></div>

      {/* Main footer content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-4 gap-12">
          {/* Column 1: Logo & Tagline */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/c7f5a085-7c77-45db-a57e-35d4ece59e26.png"
              alt="SportivaTech"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-gray-400 italic leading-relaxed">
              Accelerating digital transformation through human-centered technology
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Services', 'Contact'].map((item, idx) => (
                <li key={idx}>
                  <Link
                    to={`/${item.toLowerCase().replace(' ', '-')}`}
                    className="text-white/70 hover:text-[#00d4ff] transition-colors text-base cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Expertise Areas */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Expertise Areas</h4>
            <ul className="space-y-3">
              {['Education Technology', 'AI & Data Solutions', 'Sport Technologies', 'Accessibility Design'].map((item, idx) => (
                <li key={idx}>
                  <Link
                    to="/expertise"
                    className="text-white/70 hover:text-[#00d4ff] transition-colors text-base cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Newsletter */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Stay Updated</h4>
            <p className="text-sm text-gray-400 mb-4">Get insights on digital transformation</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 bg-transparent border border-white/30 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-[#00d4ff] transition-colors text-sm"
              />
              <button className="px-6 py-2 bg-[#00d4ff] text-white rounded-lg hover:bg-[#00b8e6] transition-colors font-semibold text-sm whitespace-nowrap cursor-pointer">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          {/* Copyright */}
          <div className="text-sm text-gray-400">
            © 2025 SportivaTech. All rights reserved.
          </div>

          {/* Trust badges */}
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-shield-check-line text-2xl"></i>
              <span className="text-xs">GDPR</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-user-heart-line text-2xl"></i>
              <span className="text-xs">WCAG AA</span>
            </div>
            <div className="flex items-center gap-2 text-gray-400">
              <i className="ri-award-line text-2xl"></i>
              <span className="text-xs">ISO 27001</span>
            </div>
          </div>

          {/* Social media & Readdy link */}
          <div className="flex items-center gap-4">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00d4ff] transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-2xl"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00d4ff] transition-colors cursor-pointer">
              <i className="ri-twitter-fill text-2xl"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00d4ff] transition-colors cursor-pointer">
              <i className="ri-instagram-fill text-2xl"></i>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00d4ff] transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-2xl"></i>
            </a>
            <span className="text-gray-500 mx-2">|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00d4ff] transition-colors text-sm cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
